<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

// `match: 'any'` lets in a user holding at least one of the actions, for a
// page whose blocks each trim themselves to the one they need.
const props = withDefaults(
  defineProps<{ actions: string[]; accountId?: string; match?: 'all' | 'any' }>(),
  { accountId: undefined, match: 'all' }
);

const authStore = useAuthStore();
const router = useRouter();
const ready = ref(false);

const resourceId = computed(() => (props.accountId ? `account:${props.accountId}` : undefined));
function holds(action: string): boolean {
  return authStore.user?.isAuthorised(action, resourceId.value) ?? false;
}
const authorized = computed(() =>
  props.match === 'any' ? props.actions.some(holds) : props.actions.every(holds)
);

onMounted(async () => {
  await authStore.initialize();
  ready.value = true;
  if (!authorized.value) {
    router.replace('/unauthorised');
  }
});
</script>

<template>
  <slot v-if="ready && authorized" />
</template>
